import React from "react";

const DataTable = ({
    columns = [],
    rows = [],
    emptyText = "No records found.",
    rowKey = "id",
}) => {
    return (
        <div className="bg-white rounded-2xl shadow border border-slate-200 overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-slate-100">
                        <tr>
                            {columns.map((col) => (
                                <th
                                    key={col.key}
                                    className="text-left px-4 py-3 font-bold text-slate-700"
                                >
                                    {col.label}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {rows.length === 0 ? (
                            <tr>
                                <td
                                    colSpan={columns.length}
                                    className="text-center py-8 text-slate-500"
                                >
                                    {emptyText}
                                </td>
                            </tr>
                        ) : (
                            rows.map((row, index) => (
                                <tr
                                    key={row[rowKey] ?? index}
                                    className="border-t hover:bg-slate-50 transition"
                                >
                                    {columns.map((col) => (
                                        <td
                                            key={col.key}
                                            className="px-4 py-3 text-slate-700 align-top"
                                        >
                                            {col.render
                                                ? col.render(row, index)
                                                : row[col.key] ?? "�"}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default DataTable;